import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BarChart3, Activity, Menu, X, Palette, BookOpen, Search, Gift, FileCheck, Key, Users } from 'lucide-react';

const Navigation = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  
  const isActive = (path) => location.pathname === path || 
    (path === '/dashboard' && location.pathname === '/');
  
  // Gruppiert nach Funktion:
  // 1. Analyse & Übersicht
  // 2. Kunden-Features  
  // 3. Admin/Tools
  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: Activity },
    { path: '/optimizer', label: 'Analyzer', icon: BarChart3 },
    { path: '/seo', label: 'SEO', icon: Search },
    { path: '/designer', label: 'Content', icon: Palette },
    { path: '/zusammenbesteller', label: 'Gruppen', icon: Users },
    { path: '/thesis-checker', label: 'Studenten', icon: FileCheck },
    { path: '/sponsoring', label: 'Partner', icon: Gift },
    { path: '/premium-codes', label: 'Codes', icon: Key },
    { path: '/docs', label: 'Docs', icon: BookOpen },
  ];
  
  return (
    <nav className="fixed top-0 left-0 right-0 bg-white border-b border-slate-200 z-50" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <Link to="/dashboard" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center">
              <BarChart3 className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-900 hidden sm:block">ADAG Optimizer</span>
          </Link>
          
          {/* Mobile menu button */}
          <button 
            onClick={() => setMenuOpen(!menuOpen)}
            className="sm:hidden p-2 rounded-lg hover:bg-slate-100"
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          
          {/* Desktop nav */}
          <div className="hidden sm:flex space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
                    isActive(item.path)
                      ? 'bg-slate-900 text-white'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="font-medium text-sm">{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
        
        {/* Mobile menu */}
        {menuOpen && (
          <div className="sm:hidden pb-4 space-y-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive(item.path)
                      ? 'bg-slate-900 text-white'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;